import { alertSlice } from './slice';

export * from './alert';

const Reducer = alertSlice.reducer;
const Actions = alertSlice.actions;

export { Reducer, Actions };
